<template>
    <v-card elevation="0" class="py-5">
        <v-card-text class="pa-1">
            <v-row>
                <v-col cols="12" sm="4">
                    <div class="subtitle-1 font-weight-bold mb-3">
                        {{
                            $t('resources.planProposal.show.texts.base-price')
                        }}:

                        {{ this.planProposal.planPackage.formattedPrice }}
                    </div>
                    <div class="subtitle-1 font-weight-bold py-2">
                        {{
                            $t('resources.planProposal.show.texts.total-price')
                        }}
                        <br />
                        <span class="pl-2 body-2">
                            {{ this.planProposal.totalPrice }}
                        </span>
                    </div>
                    <div class="subtitle-1 font-weight-bold py-2">
                        {{ $t('resources.planProposal.show.texts.discount') }}
                        <br />
                        <span class="pl-2 body-2">
                            {{ this.planProposal.discountValue }}
                        </span>
                    </div>
                    <div class="subtitle-1 font-weight-bold py-2">
                        {{
                            $t('resources.planProposal.show.texts.final-price')
                        }}
                        <br />
                        <span class="pl-2 body-2">
                            {{ this.planProposal.finalPrice }}
                        </span>
                    </div>
                    <div
                        class="subtitle-1 font-weight-bold py-2"
                        v-if="showConfigPrice"
                    >
                        {{
                            $t('resources.planProposal.show.texts.config-price')
                        }}
                        <br />
                        <span class="pl-2 body-2">
                            {{ this.planProposal.configPrice }} ({{
                                $t(
                                    'resources.planProposal.show.texts.config-price-suffix',
                                )
                            }})
                        </span>
                    </div>
                </v-col>
                <v-col cols="6" sm="4">
                    <div class="subtitle-1 font-weight-bold">
                        {{
                            $t(
                                'resources.planProposal.show.texts.fixed-modules',
                            )
                        }}
                    </div>

                    <span
                        v-for="module in fixedModules"
                        :key="`fixed_${module.id}`"
                        class="pl-2 pt-3"
                    >
                        <span v-if="module.price_type !== 'flat'">
                            {{ module.amount }}x
                        </span>
                        {{ module.module.name }}<br />
                    </span>
                </v-col>
                <v-col cols="6" sm="4">
                    <div class="subtitle-1 font-weight-bold">
                        {{
                            $t(
                                'resources.planProposal.show.texts.optional-modules',
                            )
                        }}
                    </div>

                    <span
                        v-for="module in optionalModules"
                        :key="`optional_${module.external_id}`"
                        class="pl-2 pt-3"
                    >
                        <span v-if="module.price_type !== 'flat'">
                            {{
                                module.add_amount > 0
                                    ? module.add_amount
                                    : module.amount
                            }}x
                        </span>
                        {{ module.name }}<br />
                    </span>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        planProposal: {
            type: Object,
            required: true,
        },
    },

    computed: {
        showConfigPrice() {
            return (
                !this.planProposal.proposal.loyalty &&
                this.planProposal.planPackage.config_price > 0
            )
        },

        fixedModules() {
            const modules = this.planProposal.planPackage.modules

            if (!Array.isArray(modules)) {
                return []
            }

            return this.$lodash.sortBy(
                modules.filter(
                    module =>
                        !module.add_on &&
                        (module.amount == null ||
                            typeof module.amount == undefined ||
                            module.amount > 0) &&
                        !module.locked,
                ),
                'order',
            )
        },

        optionalModules() {
            const fixedModuleIds = new Set(
                this.fixedModules.map(m => m.module.id),
            )

            return this.planProposal.proposal.modules.filter(module => {
                const isChecked = module.checked
                const hasValidAmount =
                    module.add_amount > 0 ||
                    module.add_amount == null ||
                    (module.checked && module.add_amount == 0)
                const isNotInFixed =
                    !fixedModuleIds.has(module.module_id) ||
                    (fixedModuleIds.has(module.module_id) &&
                        module.add_amount > 0) // Não está nos fixedModules ou está nos fixedModules porém com add_amount > 0

                return isChecked && hasValidAmount && isNotInFixed
            })
        },
    },
}
</script>

<style></style>
